<template>
    <span>
        <r-button :disabled="isProcessing" @click="showModal">Reschedule</r-button>
        <v-modal title="Scheduled Time" v-if="isModalVisible" @close="closeModal" @submit="inputDate && submit()">
            <template slot="content">
                <v-error-messages  :has-frontend-errors="$v.$error" class="stack-l">
                    <li class="list-item" v-if="!$v.inputDate.mustBeValidDate">You must enter a valid date.</li>
                    <li class="list-item" v-else-if="!$v.inputDate.mustBeGreaterThanToday">You must enter a date greater than today.</li>
                </v-error-messages>
                <v-date-input :help-text="inputHelpText" v-model="inputDate"/>
            </template>
            <template slot="actions">
                <r-button type="primary" :disabled="!inputDate || $v.inputDate.$error" @click="submit">Apply</r-button>
            </template>
        </v-modal>
    </span>
</template>

<script>
    import {vDateInput} from '@/components/form/index';
    import vModal from '@/components/modal/v-modal';
    import vErrorMessages from '@/components/form/v-error-messages';

    export default {
        name: 'datetime-form-modal',
        components: {
            vDateInput,
            vErrorMessages,
            vModal,
        },
        props: {
            startDatetime: {
                type: String,
                default: null,
            },
            isProcessing: {
                type: Boolean,
                required: false,
                default: false,
            },
        },
        computed: {
            inputHelpText() {
                return `originally scheduled on ${this.$filters.dateTime(this.startDatetime)}`;
            },
            originalScheduledDate() {
                return this.$tz().readUTC(this.startDatetime);
            },
        },
        data() {
            return {
                isModalVisible: false,
                inputDate: this.originalScheduledDate,
            };
        },
        validations: {
            inputDate: {
                mustBeValidDate(date) {
                    return date.isValid();
                },
                mustBeGreaterThanToday(date) {
                    return +date > +this.$tz().now();
                },
            },
        },
        methods: {
            showModal() {
                this.isModalVisible = true;
                this.inputDate = this.originalScheduledDate;
            },
            closeModal() {
                this.isModalVisible = false;
            },
            submit() {
                this.$v.$touch();
                if (!this.$v.$error) {
                    this.$emit('submit', this.inputDate.format());
                    this.closeModal();
                }
            },
        },
    };
</script>
